module.exports = __webpack_public_path__ + "cdaf243328e217f58aa0f64acbf71ba9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/pricing/plus.png
// module id = 444
// module chunks = 0